/**
 * @module lib/commercial/keytar/promotion
 */
import MeteredWall from "lib/commercial/keytar/MeteredWall";
import template from "./template";
import tgamConfig from "config/tgam";
import { WALL_TYPES } from "lib/commercial/keytar/WallAnalyticsSchema";
import { isFreeToViewReferrer } from "lib/commercial/keytar/helpers";
import consts from "lib/consts";
import isNil from "lodash/isNil";
import { getProp } from "utils/utils";
import logger from "utils/logger";
import { processObjectMethods } from "../helpers";
import { isTimedEnabledFeature } from "utils/time-restricted";

const name = "promoPaywall";
const debugTag = `[KEYTAR] ${name}`;

const epochNow = Math.floor(new Date().getTime() / 1000); // mockable global var
const wallStart = parseInt(getProp(tgamConfig, "keytar.promoPaywallStart", 0), 10);
const wallEnd = parseInt(getProp(tgamConfig, "keytar.promoPaywallEnd", 0), 10);

const rules = [{
  /** @returns {Boolean} true when access is allowed for user */
  accessAllowed({ customer, paywallStatus, meter }) {
    if (isNil(customer)) {
      return false;
    }
    const allowed = {
      isFreeToView: () => isFreeToViewReferrer(),
      isReg: () => customer.canAccessRegisteredContent,
      isBlue: () => paywallStatus === "blue",
      isYellow: () => paywallStatus === "yellow" && !meter.full
    };
    const access = processObjectMethods(allowed);
    logger.info(`${debugTag} access:`, access, allowed);
    return access;
  },
  /** @returns {Boolean} true when wall should be used for article page */
  matcher({ paywallStatus }) {
    return ["red", "yellow", "blue"].includes(paywallStatus);
  },
  /** @returns {Boolean} true when meter should be incremented for article page */
  counter: ({ paywallStatus }) => {
    return !["red"].includes(paywallStatus);
  },
  /** @type {String} */
  name: name
}];

const props = {
  rules,
  suppressed: params => { // optional override params for automated testing
    return !isTimedEnabledPromoPaywall(params);
  },
  featureFlagName: `${name}Enabled`, // defined in environment-variables.jsp
  template,
  meterKey: "wall.subscriber", // shared with other walls
  meterLimit: consts.KEYTAR.REGWALL.LIMIT, // page-views
  meterRenew: consts.KEYTAR.REGWALL.RENEW // days
};

export default new MeteredWall("regwall", WALL_TYPES.REGWALL_METERED, props);

export function isTimedEnabledPromoPaywall(params) {
  return isTimedEnabledFeature({
    start: getProp(params, "start") || wallStart,
    now: getProp(params, "now") || epochNow,
    end: getProp(params, "end") || wallEnd
  });
}
